import React from "react";

import Textarea, { TextareaProps } from "../../components/Common/Textarea/Textarea";
import { FieldErrorMessage } from "../FieldErrorMessage";
import { useFieldContext } from "../formContext";

type FormTextareaProps = Omit<TextareaProps, "name" | "value" | "onChange" | "onBlur">;

/**
 * Adapter: web's `Textarea` bound to the current field, followed by its error message. The field value
 * must be `string`; `useFieldContext<V>` is not checked against the form.
 */
export const FormTextarea: React.FC<FormTextareaProps> = (props) => {
  const field = useFieldContext<string>();

  return (
    <>
      <Textarea
        {...props}
        name={field.name}
        value={field.state.value}
        onBlur={field.handleBlur}
        onChange={(event) => field.handleChange(event.currentTarget.value)}
      />
      <FieldErrorMessage />
    </>
  );
};
